module.exports = __webpack_public_path__ + "img/list_Character_sq_06.5e3809f8.jpeg";